export const parseBold = (text, boldClassName = '') => {
  if (typeof text !== 'string') return text;

  const parts = text.split(/(\*\*[^*]+\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={index} className={boldClassName}>
          {part.replace(/\*\*/g, '')}
        </strong>
      );
    }

    return part;
  });
};